import { Injectable } from '@angular/core';

import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Helpers } from '@recruitee/common';
import { HttpApiService } from '@recruitee/http';
import type { ID } from '@recruitee/ngrx';

import type { SlackIntegrationHttp } from '../types';

@Injectable({ providedIn: 'root' })
export class SlackIntegrationHttpService {
  constructor(protected httpApi: HttpApiService) {}

  public getCollection(): Observable<any> {
    return this.httpApi
      .get('/tracking/slack_integrations')
      .pipe(map(response => response.slackIntegrations));
  }

  public deleteIntegration(slackIntegrationId: ID): Observable<any> {
    return this.httpApi.delete(`/tracking/slack_integrations/${slackIntegrationId}`);
  }

  public disconnectAll(): Observable<any> {
    return this.httpApi.patch(`/tracking/slack_integrations/disconnect_all`);
  }

  public updateIntegration(payload: SlackIntegrationHttp): Observable<any> {
    const events = Object.keys(payload.activitySubscriptions);
    const values = Object.values(payload.activitySubscriptions);

    return this.httpApi.patch(
      `/tracking/slack_integrations/${payload.id}/update_activity_subscriptions`,
      { events: events.map(Helpers.underscore), value: values[0].slack },
      null,
    );
  }
}
